@if (mode === 'renderer') {
  <div
    class="video-dc"
    [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-right.px': element.fields.marginRight,
      'margin-bottom.px': element.fields.marginBottom,
      'margin-left.px': element.fields.marginLeft,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft,
      'background-color': element.fields.backgroundColor,
      'height.px': !element.fields.responsive ? element.fields.height : null
    }"
  >
    @if (element.fields.videoUrl) {
      <video
        [src]="element.fields.videoUrl"
        [class.w-100]="element.fields.responsive"
        [style.height.px]="!element.fields.responsive ? element.fields.height : null"
        [class.h-100]="!element.fields.responsive"
        [autoplay]="element.fields.autoplay"
        [controls]="element.fields.controls"
        [muted]="element.fields.muted"
        [loop]="element.fields.loop"
      ></video>
    } @else if (edit) {
      <div class="text-center empty-video">
        <i class="fa-solid fa-video fa-2x mb-2"></i>
        <p>{{ 'ADD_VIDEO_URL_OR_UPLOAD' | translate }}</p>
      </div>
    }
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Content</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12 mb-2">
              <div class="d-flex justify-content-between">
                <div class="form-group">
                  <label [for]="idUploadInput">{{ 'VIDEO_URL' | translate }}</label>
                  <input type="text" class="form-control" id="{{ idUploadInput }}" [(ngModel)]="element.fields.videoUrl" [placeholder]="'VIDEO_URL_HTTP' | translate" />
                </div>
                <div (click)="uploadVideo()" class="cursor-pointer upload-image" title="{{ 'UPLOAD_VIDEO' | translate }}">
                  <i class="fa-solid fa-upload"></i>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="element.fields.responsive"
                  id="video-responsive"
                />
                <label class="form-check-label" for="video-responsive">{{ 'RESPONSIVE' | translate }}</label>
              </div>
            </div>
            @if (!element.fields.responsive) {
              <div class="col-12">
                <lib-gung-number-input
                  [gungTranslate]="'Fixed height'"
                  [(ngModel)]="element.fields.height"
                ></lib-gung-number-input>
              </div>
            }
            <div class="col-12 mt-2">
              <strong>{{ 'VIDEO_OPTIONS' | translate }}</strong>
            </div>
            <div class="col-12">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="element.fields.controls"
                  id="video-controls"
                />
                <label class="form-check-label" for="video-controls">{{ 'CONTROLS' | translate }}</label>
              </div>
            </div>
            <div class="col-12">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="element.fields.autoplay"
                  id="video-autoplay"
                />
                <label class="form-check-label" for="video-autoplay">{{ 'AUTOPLAY' | translate }}</label>
              </div>
            </div>
            <div class="col-12">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="element.fields.muted"
                  id="video-muted"
                />
                <label class="form-check-label" for="video-muted">{{ 'MUTED' | translate }}</label>
              </div>
            </div>
            <div class="col-12">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="element.fields.loop"
                  id="video-loop"
                />
                <label class="form-check-label" for="video-loop">{{ 'LOOP' | translate }}</label>
              </div>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Styles</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <lib-gung-accordion #acc="gungAccordion" [closeOthers]="false">
            <lib-gung-accordion-item [collapsed]="true">
              <ng-template libGungAccordionHeader>General Settings</ng-template>
              <ng-template libGungAccordionBody>
                <div class="row">
                  <lib-dynamic-page-element-margin-padding
                    [(marginTop)]="element.fields.marginTop"
                    [(marginRight)]="element.fields.marginRight"
                    [(marginBottom)]="element.fields.marginBottom"
                    [(marginLeft)]="element.fields.marginLeft"
                    [(paddingTop)]="element.fields.paddingTop"
                    [(paddingRight)]="element.fields.paddingRight"
                    [(paddingBottom)]="element.fields.paddingBottom"
                    [(paddingLeft)]="element.fields.paddingLeft"
                  ></lib-dynamic-page-element-margin-padding>
                  <div class="col-12">
                    <div class="d-flex color-dp-input">
                      <lib-gung-text-input
                        [gungTranslate]="'BACKGROUND'"
                        [(ngModel)]="element.fields.background"
                      ></lib-gung-text-input>
                      <input class="input-color" type="color" [(ngModel)]="element.fields.backgroundColor" />
                    </div>
                  </div>
                </div>
              </ng-template>
            </lib-gung-accordion-item>
          </lib-gung-accordion>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="preview-card-info d-flex align-items-center justify-content-center">
    <i class="fa-solid fa-circle-play"></i>
  </div>
}
